import React from "react";
export default React.createClass({
    render: function(){
        let options = this.props.options;
        return(
            <div id={this.props.field + "-group"} className="form-div row">
              <div className={this.props.bigLabel ? "col-sm-7" : "col-sm-4"}>
                <label htmlFor={this.props.field}>{this.props.label}
                {this.props.requiredField &&
                  <span className="requiredField"> * </span>
                }
                </label>
              </div>
              <div className={this.props.bigLabel ? "col-sm-5 select-wrap" : "col-sm-8 select-wrap"}>
                <select ref={this.props.field} name={this.props.field} id={this.props.field} className="form_item_select" required onChange={this.props.onChange} defaultValue="">
                    <option value="" >{this.props.placeholder}</option>
                    {options.map((object, i) => <option value={options[i].value} key={i}>{options[i].label}</option>)}
                </select>
              </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/js/components/elements/select-row.jsx